import React from "react";
import { Link } from "react-router-dom";
import PayrollAnalytics from "../../components/analytics/PayrollAnalytics";

/**
 * Dedicated Payroll analytics page.
 * Mounted at two routes in App.js:
 *   owner: /analytics/payroll              -> <PayrollAnalyticsPage isPortal={false} />
 *   staff: /staff-panel/analytics/payroll  -> <PayrollAnalyticsPage isPortal={true} />
 *
 * Staff route is gated with ModuleGuard PAYROLL_MANAGEMENT + PermissionGuard PAYROLL_MANAGEMENT_VIEW.
 */
const PayrollAnalyticsPage = ({ isPortal = false }) => {
  const homeUrl = isPortal ? "/staff-home" : "/school-home";
  const hubUrl = isPortal ? "/staff-panel/analytics" : "/analytics";

  return (
    <div className="min-h-screen bg-neutral-100 dark:bg-neutral-800 dark:bg-neutral-900">
      <div className="max-w-6xl mx-auto p-6">
        <nav className="mb-4 flex flex-wrap items-center gap-2 text-sm text-neutral-500 dark:text-neutral-400">
          <Link to={homeUrl} className="hover:text-indigo-600">
            Home
          </Link>
          <span>/</span>
          <Link to={hubUrl} className="hover:text-indigo-600">
            Analytics
          </Link>
          <span>/</span>
          <span className="font-medium text-neutral-800 dark:text-neutral-100">Payroll Analytics</span>
        </nav>

        <h1 className="text-2xl font-bold text-neutral-800 dark:text-neutral-100 mb-6">Payroll Analytics</h1>

        <PayrollAnalytics isPortal={isPortal} />
      </div>
    </div>
  );
};

export default PayrollAnalyticsPage;
